import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { EASE } from "@/lib/site";
import { Eyebrow } from "@/components/ui-kit/Reveal";
import QuoteButton from "@/components/ui-kit/QuoteButton";

export default function PlaceholderPage({ title, eyebrow, image, intro, quote, hideCta, children }) {
  const aside = image || quote;
  return (
    <>
    <section data-testid="placeholder-page" className="relative bg-[var(--paper)] overflow-hidden">
      <div aria-hidden className="absolute -right-20 top-10 w-[60%] h-[3px] bg-[var(--red)] -rotate-[18deg] opacity-70" />
      <div className={`relative max-w-7xl mx-auto px-4 sm:px-8 py-20 sm:py-28 ${aside ? "grid lg:grid-cols-12 gap-12 lg:gap-14 items-center" : "sm:py-36"}`}>
        <div className={aside ? "lg:col-span-6" : ""}>
        <Eyebrow>{eyebrow}</Eyebrow>
        <div className="overflow-hidden mt-6">
          <motion.h1 data-testid="placeholder-page-title" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 1, ease: EASE }}
            className="font-display italic font-black uppercase text-6xl sm:text-7xl lg:text-8xl leading-[0.9] text-[var(--ink)]">{title}</motion.h1>
        </div>
        <p data-testid="page-intro" className="mt-8 max-w-xl text-base sm:text-lg text-slate-600 leading-relaxed">
          {intro || "This page is coming in the next step. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."}
        </p>
        {!hideCta && <QuoteButton testId="placeholder-quote-button" className="mt-10" />}
        </div>
        {quote && (
          <motion.figure data-testid="page-quote" initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, delay: 0.3, ease: EASE }}
            className="lg:col-span-6 relative">
            <div className="chamfer grain relative bg-[var(--navy)] text-white px-8 py-12 sm:px-12 sm:py-16 overflow-hidden">
              <div aria-hidden className="absolute -right-10 bottom-16 w-[80%] h-[4px] bg-[var(--red)] -rotate-[14deg]" />
              <Quote className="relative w-12 h-12 text-[#ff4d53] fill-[#ff4d53]" />
              <blockquote className="relative mt-8 font-display italic font-extrabold uppercase text-3xl sm:text-4xl lg:text-[2.6rem] leading-[1.05]">{quote.text}</blockquote>
              <figcaption className="relative mt-10 flex items-center gap-4">
                <span className="w-10 h-[3px] bg-[#ff4d53] -skew-x-[30deg]" />
                <span>
                  <span className="block font-bold text-lg">{quote.name}</span>
                  <span className="block text-sm text-white/80">{quote.role}</span>
                </span>
              </figcaption>
            </div>
          </motion.figure>
        )}
        {image && (
          <motion.div initial={{ clipPath: "inset(0 0 100% 0)" }} animate={{ clipPath: "inset(0 0 0% 0)" }} transition={{ duration: 1.2, delay: 0.2, ease: EASE }}
            className="lg:col-span-6 relative">
            <div className="chamfer relative aspect-[5/4] overflow-hidden bg-[var(--navy)]">
              <motion.img data-testid="page-banner-image" src={image.src} alt={image.alt} initial={{ scale: 1.15 }} animate={{ scale: 1 }}
                transition={{ duration: 1.6, delay: 0.2, ease: EASE }} className="absolute inset-0 w-full h-full object-cover object-[50%_45%]" />
            </div>
            <div aria-hidden className="absolute -right-3 -bottom-3 w-24 h-24 border-r-[6px] border-b-[6px] border-[var(--red)]" />
          </motion.div>
        )}
      </div>
    </section>
    {children}
    </>
  );
}
